// extracted by mini-css-extract-plugin
export default {"success":"C5SPeAVK","mobile":"mobile","text":"q6YV3PkN","link":"_Nc61YlU"};